import { useEffect, useState } from "react";
import type { StoneRequestMode } from "@gull/shared";

export function useStoneHandling(itemCount: number) {
  const [mode, setMode] = useState<StoneRequestMode>("NONE_OR_KEEP");
  const [selectedItemIndexes, setSelectedItemIndexes] = useState<number[]>([]);
  const [salesTermsAccepted, setSalesTermsAccepted] = useState(false);

  useEffect(() => {
    setSelectedItemIndexes((prev) => prev.filter((index) => index < itemCount));
  }, [itemCount]);

  const restore = (restoredMode: StoneRequestMode, restoredSelectedItemIndexes: number[]) => {
    setMode(restoredMode);
    setSelectedItemIndexes(restoredSelectedItemIndexes);
  };

  const selectionMissing = mode === "SPECIFIC" && selectedItemIndexes.length === 0;

  return {
    mode,
    setMode,
    selectedItemIndexes,
    setSelectedItemIndexes,
    salesTermsAccepted,
    setSalesTermsAccepted,
    selectionMissing,
    restore,
  };
}

export type StoneHandlingDraft = ReturnType<typeof useStoneHandling>;
